import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export var topNegative = byMedia(function (value) {
  return "top: -" + getPx(value) + ";";
});
export var topHalfNegative = byMedia(function (value) {
  return "top: calc(-" + getPx(value) + " / 2);";
});